export const isNull = (value: any): boolean => {
  try {
    return value === null || value === "null";
  } catch {
    return false;
  }
};
